import React from 'react';
import Header from "../components/Header";
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function SBMSAccess() {
    const navigate = useNavigate();

    return (  
        <div data-testid="home-container" id="home-container">
            <Header
                showSideBarMenu={true}
                showDashboardMenu={false}
                height={56} 
                className="pb-5"
            />
            <main style={{color: "white", textAlign: "center"}}>
                <br />
                <h1>Space Cockpit Battle Management System (SBMS)</h1>
                <p className="mt-3">SBMS is free to access for US DoD and government users only.</p>
                <p>Log in using an UDL account tied to your DoD or government email address. For excercise or conditional access, contact us by emailing <a href="mailto:spacecockpit@saberastro.com" style={{ color: '#f5bc59' }}>spacecockpit@saberastro.com</a></p>
                <Button
                    variant="warning"
                    onClick={() => navigate("/")}
                    className="mt-2"
                >
                    Back to login
                </Button>
            </main>
        </div>
    );
}

export default SBMSAccess;
